<script>
    /** @type {string} */
    export let img;
    export let alt;
</script>

<figure
  class="document-placeholder">
  <picture>
    <!-- <source
      type="image/avif"
      srcset={avif}
      />
    <source
      type="image/webp"
      srcset={webp}
      /> -->
    <img 
      src={img} 
      class="document-img"
      alt={alt}
      />
  </picture>
</figure>